import { notification } from 'antd';
import { useCallback, useEffect, useState } from 'react';

import apiShipper from '../../../../services/apiShipper';

function useCotacaoData(idCotacao) {
  const [cotacao, setCotacao] = useState({});
  const [loading, setLoading] = useState(false);

  const fetchCotacao = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await apiShipper.get(`cotacoes/${idCotacao}`);
      setCotacao(data);
    } catch (error) {
      notification.error({
        message: 'Não foi possível obter os dados da cotação',
        description: 'Tente novamente ou entre em contato com o suporte',
      });
    } finally {
      setLoading(false);
    }
  }, [idCotacao]);

  useEffect(() => {
    const onInit = async () => {
      await fetchCotacao();
    };
    onInit();
  }, [fetchCotacao]);

  return {
    cotacao,
    loading,
    fetchCotacao,
  };
}
export default useCotacaoData;
